<template>
    <div>
        <div class="advtisement" @click="goDatails(url)">
            <div>
                <img :src="imgSrc" alt="广告图">
            </div>
            <div>{{des}}</div>
        </div>
    </div>
</template>
<script>
import { Dialog } from "vant";
export default {
    name:"advtisement",
    data() {
        return{

        }
    },
    props:['imgSrc','des','url'],
    methods:{
        goDatails(url){
            if(!url) {
                return;
            }
            if(!url.includes('jfbst.com')) {
                Dialog.confirm({
                    message: "您将进入第三方平台。相关服务和责任将由该第三方承担。如有问题请咨询该平台客服"
                }).then(() => {
                window.location.href = url;
                })
            } else {
                window.location.href = url;
            }
        }
    }
}
</script>
<style scoped>
.advtisement{
  width:355px;
  margin: 0 auto;
  margin-top:10px;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
}
.advtisement img{
    width:100%;
}
.advtisement>div:nth-child(2){
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: #666666;
    font-size:13px;
}
</style>